import { IconCheck } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Forms.module.css';

export interface FillStep {
  title: string;
  text: string;
  /** `done`: tamam (yeşil tik); `current`: sıradaki adım (mavi). */
  state?: 'done' | 'current' | undefined;
  /** Adımın kendi düğmesi ya da bağlantısı. */
  children?: ReactNode;
}

/**
 * Numaralı kısa akış (sahip kararı 2026-10-17; ADR 0074): form sayfasının sağ kartında dikey,
 * kayıt sayfasında yatay üç adım. Numaralar arasında ince bir çizgi; tamam adımda tik, sıradaki
 * adım mavi. Liste `<ol>`dir; tamam bilgisi ekran okuyucuya da yazılır.
 */
export function FillSteps({
  steps,
  layout = 'vertical',
}: {
  steps: readonly FillStep[];
  layout?: 'vertical' | 'horizontal';
}) {
  const { t } = useTranslation();
  return (
    <ol className={classes.fillSteps} data-layout={layout}>
      {steps.map((step, index) => (
        <li
          key={step.title}
          className={classes.fillStep}
          data-done={step.state === 'done' || undefined}
          data-current={step.state === 'current' || undefined}
        >
          <span className={classes.fillNumber} aria-hidden="true">
            {step.state === 'done' ? <IconCheck size={14} stroke={3} /> : index + 1}
          </span>
          <div className={classes.fillBody}>
            <p className={classes.fillTitle}>
              {step.title}
              {step.state === 'done' ? (
                <span className={classes.srOnly}> ({t('forms.guide.done')})</span>
              ) : null}
            </p>
            <p className={classes.fillText}>{step.text}</p>
            {step.children}
          </div>
        </li>
      ))}
    </ol>
  );
}
